'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'chevrons-up';
var width = 512;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M278.6 41.4L256 18.7 233.4 41.4l-192 192L18.7 256 64 301.3l22.6-22.6L256 109.3 425.4 278.6 448 301.3 493.3 256l-22.6-22.6-192-192zm0 192L256 210.7l-22.6 22.6-192 192L18.7 448 64 493.3l22.6-22.6L256 301.3 425.4 470.6 448 493.3 493.3 448l-22.6-22.6-192-192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;